import { render, staticRenderFns } from "./product-card.vue?vue&type=template&id=f2ab045e&scoped=true&"
import script from "./product-card.vue?vue&type=script&lang=js&"
export * from "./product-card.vue?vue&type=script&lang=js&"
import style0 from "./product-card.vue?vue&type=style&index=0&id=f2ab045e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ab045e",
  null
  
)

export default component.exports